<template src="@/templates/dhs/jobsModel.html"></template>

<script>
	import Config from '../../config/config'
	import moment from 'moment'
	import InterpreterDetails from '@/components/dhs/interpreterDetails'

	export default {
		name: "JobsModel",
		props: ['modelData', 'category', 'viewActivitiesList'],
		components: {
			InterpreterDetails
		},
		data() {
			return {
				currentDate: moment().format('DD MMM YYYY'),
				showingCurrentDate: false,
				jobsModel: {
					data: {},
					category: ''
				},
				customClass: {
					emptyClass: '',
					reliefClass: '',
					trClass: ''
				},
				viewIntDetailsModal: false,
				timers: {},
				breakTime: 2100000, //35 minutes,
				dynamicContent: ''
			}
		},
		created() {

			console.log('modelData')
			console.log(this.modelData)

			this.jobsModel.data = this.modelData;
			this.jobsModel.category = this.category;
			this.processActivityStatusRules()
		},
		mounted() {
			// this.socket.on("activity-status-message", function (wsMessage) {
			// 	console.log('activity-status-message');
			// 	console.log(wsMessage);
			// 	console.log(wsMessage.data[0]);
			// 	console.log(wsMessage.category);
			//
			// 	this.jobsModel.data = wsMessage.data[0];
			// 	this.jobsModel.category = wsMessage.category;
			// 	this.processActivityStatusRules()
			// });

			Event.$on('jobsModelActivities', (wsMessage) => {

				if (wsMessage.data[0].job_id == this.jobsModel.data[0].job_id) {
					console.log('activity-status-message');
					console.log(wsMessage);
					console.log(wsMessage.data[0]);
					console.log(wsMessage.category);

					this.jobsModel.data = wsMessage.data[0];
					this.jobsModel.category = wsMessage.category;
					this.processActivityStatusRules();
				}
				else console.log('Not Matching');

			});
		},
		beforeDestroy() {
			Event.$off('jobsModelActivities');
		},
		methods: {
			processActivityStatusRules() {
				if (this.jobsModel.category !== 'initialization') {

					let data = this.jobsModel.data[0];
					let startDate = moment(data.service_date + " " + data.vic_service_time_start, 'DD MMM YYYY hh:mm:ss A').toDate();
					if (data.is_clocked_on == 1) {
						this.jobsModel.activityStatus = 'circleGreen';
					} else {
						this.jobsModel.activityStatus = this.checkClockOnRules(startDate, data.job_id);
					}

					if (data.is_clocked_off == 1)
						this.jobsModel.activityStatus = 'circleGreenOk';

					if (data.early_clock_off == 1)
						this.jobsModel.activityStatus = '<div class="circleRed" alt="2">2</div>';

					if (data.on_break == 0) {
						if (data.no_break == 1)
							this.jobsModel.onBreakStatus = '<div class="circleCleanWhite" alt="4">4</div>';
						else
							this.jobsModel.onBreakStatus = '<div class="circleWhite" alt="0">0</div>';

					}
					else if (data.on_break == 1)
						this.jobsModel.onBreakStatus = '<div class="circleAmber" alt="1">1</div>';
					else if (data.on_break == 2)
						this.jobsModel.onBreakStatus = '<div class="circleRedBreak" alt="2"></div>';
					else
						this.jobsModel.onBreakStatus = '<div class="circleGreen" alt="3">3</div>';


					// Notification on Activities
					let keyText = '';
					if (this.jobsModel.category === 'is_clocked_on' || this.jobsModel.category === 'is_clocked_off')
						keyText = 'Clocked On/Off status';
					else if (this.jobsModel.category === 'early_clock_off')
						keyText = 'Early Clock Off status';
					else if (this.jobsModel.category === 'no_break')
						keyText = 'Interpreter break';
					else if (this.jobsModel.category === 'is_logged_in')
						keyText = 'Logged in status';
					else {
						keyText = 'Break status';
					}

					this.showNotification("Job ID: " + data.job_id + " " + keyText + " was updated", 'success');

				}
				else {
					this.clearTimers(); //clear timers
					let data = this.jobsModel.data;
					let startDate = moment(data.service_date + " " + data.vic_service_time_start, 'DD MMM YYYY hh:mm:ss A').toDate();
					if (data.is_clocked_on == 1) {
						this.jobsModel.activityStatus = 'circleGreen';
					} else {
						this.jobsModel.activityStatus = this.checkClockOnRules(startDate, data.job_id);
						if (this.showingCurrentDate == false && moment(data.service_date, 'DD MMM YYYY').unix() < moment(this.currentDate, 'DD MMM YYYY').unix())
							this.jobsModel.activityStatus = 'circleRed';

					}

					if (data.is_clocked_off == 1)
						this.jobsModel.activityStatus = 'circleGreenOk';

					if (data.early_clock_off == 1)
						this.jobsModel.activityStatus = 'circleRed';

					if (data.on_break == 0 || data.on_break == undefined) {
						if (data.no_break == 1)
							this.jobsModel.onBreakStatus = 'circleCleanWhite';
						else
							this.jobsModel.onBreakStatus = 'circleWhite';

					} else if (data.on_break == 1) {
						this.jobsModel.onBreakStatus = 'circleAmber';

						if (this.showingCurrentDate == true)
							setTimeout(this.updateBreakStatus, (Math.abs(this.breakTime - (data.break_consumption * 60000))), data.job_id); //1 minute

					} else if (data.on_break == 2) {
						if (this.showingCurrentDate == true) {
							//get minutes of over break
							let overBreak = ((data.break_consumption * 60000) - 1800000) / 60000;
							this.jobsModel.onBreakStatus = 'circleRedBreak';
							this.jobsModel.overBreak = overBreak;
							this.registerTimer(data.job_id, overBreak);
						} else
							this.jobsModel.onBreakStatus = 'circleRed';

					} else
						this.jobsModel.onBreakStatus = 'circleGreen';

					this.customClass.emptyClass = (data.int_id == '') ? "trRed" : "";
					this.customClass.reliefClass = (data.is_relief == '1' && this.customClass.emptyClass == '') ? "trPurple" : "";
					this.customClass.trClass = (this.showingCurrentDate == false && moment(data.service_date, 'DD MMM YYYY').unix() > moment(this.currentDate, 'DD MMM YYYY').unix()) ? '' : 'dataTableTR';

					//check if date is more than todays date, if true then override status
					if (this.showingCurrentDate == false && moment(data.service_date, 'DD MMM YYYY').unix() > moment(this.currentDate, 'DD MMM YYYY').unix()) {
						this.jobsModel.activityStatus = 'circleAmber';
						this.jobsModel.onBreakStatus = 'circleWhite';
					}
				}
			},
			updateBreakStatus(jobID) {
				//get current content
				if ( this.jobsModel.onBreakStatus == 'circleAmber' ) {
					//update break status to red for the job id selected
					this.jobsModel.onBreakStatus = 'circleRedBreak';
					this.registerTimer(jobID, 5);
				}

			},
			registerTimer(jobID, ctr) {
				if (this.timers[jobID] == undefined) {
					//start timer to update minutes of
					this.timers[jobID] = {};
					this.timers[jobID]['ctr'] = ctr;
					//create interval timers
					this.timers[jobID]['timer'] = setInterval(this.updateTimer, 60000, jobID); //update timer per minute
				}
			},
			unRegisterTimer(jobID) {
				if (this.timers[jobID] != undefined) {
					this.timers[jobID]['ctr'] = 0;
					//remove interval timer
					clearInterval(this.timers[jobID]['timer']);
					delete this.timers[jobID];
				}
			},
			updateTimer(jobID) {
				//console.log("Timer is running for Job ID: " +jobID);
				if ( this.jobsModel.onBreakStatus == 'circleRedBreak' ) { // check if the status is red
					this.timers[jobID]['ctr'] += 1;
					this.jobsModel.onBreakStatus = 'circleRedBreak';
					this.jobsModel.overBreak = this.timers[jobID]['ctr'];
				}
				else
					this.unRegisterTimer(jobID); //if not remove timer from memory
			},
			clearTimers() {
				for (let i=0; i < this.timers.length; i++) {

					console.log('this.timers[i]');
					console.log(this.timers[i]);

					this.unRegisterTimer(this.timers[i]);
				}

				this.timers = {};
			},
			checkClockOnRules(strStartDate, jobId) {
				let startDate = new Date(strStartDate);
				let current = new Date();
				let diff = current - startDate;
				let diffMinutes = Math.floor((diff / 1000) / 60);
				return this.updateClockOnStatus(diffMinutes, jobId, strStartDate);

			},
			updateClockOnStatus(diffMinutes, jobId, startDate) {
				let clockOnStatus = 0; // O: the process sends a flag to update status to green
				let cssClassName = "circleAmber";
				if (0 < diffMinutes && diffMinutes <= Config.clockOnFirstInterval) {
					clockOnStatus = 1; // 1: the process sends a flag to update status to yellow
				}
				if (diffMinutes > Config.clockOnFirstInterval && diffMinutes <= Config.clockOnSecondInterval) {
					clockOnStatus = 2; // 2: the process sends a flag to update status to orange
					cssClassName = "circleOrange";
				}
				if (diffMinutes > Config.clockOnSecondInterval) {
					clockOnStatus = 3; // 3: the process sends a flag to update status to red
					cssClassName = "circleRed";
				}

				return cssClassName;
			},
			showNotification(message, type) {
				this.$bvToast.toast(
					message,
					{
						title: 'Notification',
						variant: type,
						solid: true
					}
				)
			},
			getInterpreterDetails() {
				this.viewIntDetailsModal = true;
				this.intDialogJustClosed = false;
				this.backgroundEliminator();
			},
			backgroundEliminator() {
				// Careful with this function. This is implemented to get rid of grey background covering the interpreter details popup.
				// Try to command below and see the issue.
				let select = document.getElementsByTagName('body')[0];
				setTimeout(function () {
					select.removeChild(select.lastChild);
				}, 100);
			},
			closeIntDetails() {
				this.viewIntDetailsModal = false;
				this.intDialogJustClosed = true;
			},
			getJobActivities(jobsModelData) {

				if (this.intDialogJustClosed) return;

				if(moment(this.currentDate, 'DD MMM YYYY').unix() >= moment(jobsModelData.service_date, 'DD MMM YYYY').unix()) {
					let currentState = jobsModelData.state;

					let url = Config.publicApiURL + 'interpreter/jobactivities?jobID=' + jobsModelData.job_id;

					this.$http.get(url, {
						headers: {"Bearer": localStorage.getItem("jwt")}
					}).then((res) => {

						let activities = res.data.data;
						Event.$emit('viewActivityList', activities, jobsModelData.job_id, currentState);

					}).catch(function (error) {
						console.log(error);
					});
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dhs/JobsModel.vue